module.exports = __webpack_public_path__ + "static/logo-dark-4a77fec16a0289cd98d21011a1ad0be5.svg";